
export const  LEDGER_TYPE_GROUP_NAME = {
    CASH_BOOK:"CASH BOOK",
    BANK:"BANK",
    CREDIT_CARD:"CREDIT CARD",
    CAPITAL_ACCOUNT:"CAPITAL ACCOUNT",
    CASH_CONTROLLER:"CASH CONTROLLER"
}
